import React from 'react'

type ExternalLinkProps = {
    url: string;
}

const ExternalLink: React.FC<ExternalLinkProps> = ({ url }) => {
    return (
        <a href={url} target='_blank' rel="noreferrer" >{url}</a>
    )
}

export default ExternalLink